import { Trans } from '@verto/localization'

export default Trans
